import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopLeft32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconRadiusTopLeft32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M21.063 6.73h-4.821a9 9 0 0 0-9 9v4.921a1 1 0 1 1-2 0V15.73c0-6.075 4.924-11 11-11h4.821a1 1 0 1 1 0 2m4.458 7.762a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m1.25-3.763a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-16 13.513a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m12.25 1.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-6.75-1.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m10.5-3.79a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopLeft32);
